
// eslint-disable-next-line import/prefer-default-export
export async function encodeKeystore(file) {
  const arrayBuffer = await file.arrayBuffer();
  const encoded = Buffer.from(arrayBuffer).toString('base64');
  return encoded;
}
